/**
 * Small "Test Mode" badge shown on a location card/table row when that
 * location has BOTH per-location Google Ads test toggles on:
 *   - `ghl_google_ads_settings.test_button_enabled` (the Builder renders the
 *     per-row Test upload button and the test endpoint accepts calls), AND
 *   - `ghl_google_ads_settings.test_mode_enabled` (the cron suppresses real
 *     auto-uploads for this location — tags only).
 *
 * Render it conditionally — the caller decides presence from
 * `useQualifierTestModeMap()`; the badge itself is presence = "in test mode".
 */

import { FlaskConical } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip'

export function TestModeBadge() {
  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Badge
            className="border-transparent bg-amber-100 text-amber-800 hover:bg-amber-100 gap-1 px-1.5 py-0 text-[10px] font-semibold"
            aria-label="Google Ads test mode"
          >
            <FlaskConical className="h-3 w-3" />
            Test Mode
          </Badge>
        </TooltipTrigger>
        <TooltipContent side="bottom">
          Test mode on — Test upload button enabled and the cron suppresses real
          Google Ads uploads for this location (tags only)
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  )
}
